const brightRed400Color = '#B41319';

export default brightRed400Color;
